import { render, staticRenderFns } from "./ModalWaitReport.vue?vue&type=template&id=5f8b2008&lang=pug&"
import script from "./ModalWaitReport.vue?vue&type=script&lang=js&"
export * from "./ModalWaitReport.vue?vue&type=script&lang=js&"
import style0 from "./ModalWaitReport.vue?vue&type=style&index=0&id=5f8b2008&prod&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports